/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateWhatsAppTemplateParameterMapDataSchema = z.object({
	parameterMap: z.record(z.string(), z.string()).nullable(),
})

export type UpdateWhatsAppTemplateParameterMapDataSchema = z.infer<typeof updateWhatsAppTemplateParameterMapDataSchema>
